import React, { useEffect, useState } from "react";
import { useAuth } from "../hooks/useAuth";
import { Box, Tab, CircularProgress, useTheme, useMediaQuery } from "@mui/material";
import { useNavigate, useSearchParams } from "react-router-dom";
// Make sure to import getStoreInfo here
import { getStoreInfo } from "../hooks/apiHandler";
import { GeneralSetting } from "./settings/general";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import { AddToQueue, CurrencyExchangeOutlined, Key, ManageAccounts, Notifications, Settings } from "@mui/icons-material";
import { DeviceSetting } from "./settings/Devices";
import { UserSetting } from "./settings/user";
import NotificationSettings from "./settings/notification";
import { PaymentSettingPage } from "./settings/paymentSetPage";

export const SettingsPage = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const { user, Logout } = useAuth(); // Ensure Logout is available
  const navigate = useNavigate();
  const [searchParams, ] = useSearchParams();
  const [tabno, setTabno] = useState(searchParams.get("tab") || "1");
  const [loading, setLoading] = useState(true);
  
  // StoreInfo is now managed entirely by the Parent
  const [storeInfo, setStoreInfo] = useState(null);

  // Get Store ID from local storage
  const storeid = JSON.parse(window.localStorage.getItem('ds'));

  // 1. Fetch Data in Parent
  const fetchStoreData = async () => {
    try {
      setLoading(true);
      const response = await getStoreInfo({ storeID: storeid }, Logout);
      if (response.data) {
        setStoreInfo(response.data);
      }
    } catch (error) {
      console.error("Error fetching store data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!user) {
      navigate("/login", { replace: true })
    } else {
      fetchStoreData();
    }
  }, [user, navigate, storeid]); // Added dependencies

  const tabChange = (_event, newValue) => {
    setTabno(newValue);
  }

  // Helper to update data after a child saves changes
  const handleDataUpdate = (newData) => {
    setStoreInfo(newData);
  };

  return (
    <Box sx={{ width: '100%', maxWidth: { xs: '400px', sm: '100%' }, typography: 'body1' }}>
      <TabContext value={tabno}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <TabList onChange={tabChange} aria-label="Settings" variant="scrollable" scrollButtons="auto" allowScrollButtonsMobile>
            <Tab value="1" icon={<Settings />} iconPosition="start" label="General" />
            <Tab value="2" icon={<AddToQueue />} iconPosition="start" label="Devices" />
            <Tab value="3" icon={<ManageAccounts />} iconPosition="start" label="user" />
            <Tab value="4" icon={<CurrencyExchangeOutlined />} iconPosition="start" label="Payments" />
            <Tab value="5" icon={<Notifications />} iconPosition="start" label="Notifications" />
          </TabList>
        </Box>

        {/* Show loader if data isn't ready, prevents children from crashing */}
        {loading && !storeInfo ? (
          <Box sx={{ p: 3, display: 'flex', justifyContent: 'center' }}><CircularProgress /></Box>
        ) : (
          <>
            <Box sx={{ p: isMobile ? 1 : 3 }}>
              <TabPanel value="1" sx={{ p: 0 }}>
                {/* Pass data down, and a function to refresh it if edited */}
                <GeneralSetting
                  data={storeInfo}
                  onUpdate={handleDataUpdate}
                />
              </TabPanel>
              <TabPanel value="2" sx={{ p: 0 }}><DeviceSetting /></TabPanel>
              <TabPanel key={Key} value="3"><UserSetting /></TabPanel>
              {/* Now storeInfo is guaranteed to be available when this mounts */}
              <TabPanel value="4" sx={{ p: 0 }}><PaymentSettingPage storeInfo={storeInfo} /></TabPanel>
              <TabPanel value="5" sx={{ p: 0 }}><NotificationSettings /></TabPanel>
            </Box>
          </>
        )}
      </TabContext>
    </Box>
  )
};
